import React from 'react'
import { BANKING_BOTTOM_CONTENT, DESIGN_COURSE_PAGE_2, DESIGN_DETAILS_PAGE_2, DESIGN_HERO_PAGE_2 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { DESIGN_ACCORDIAN_2 } from '../../../utils/courseConifg'

const DesignPage_2 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...DESIGN_HERO_PAGE_2}/>
     <CoursesAside {...DESIGN_COURSE_PAGE_2}/>
     <CourseCard {...DESIGN_DETAILS_PAGE_2}/>
     <Accordian {...DESIGN_ACCORDIAN_2}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default DesignPage_2